import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorSeries,
  fetchProcessorSeriesAttributes,
  fetchProcessorSeriesById,
  updateProcessorSeries,
  updateStatusInProcessorSeries,
} from "./thunk";

interface CategoryState {
  processor_series_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_series_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_series",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorSeriesAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorSeriesAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_series_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorSeriesAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchProcessorSeriesById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorSeriesById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorSeriesById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorSeries.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_series_list = state.processor_series_list.map((processor_series) =>
          processor_series.id === action.payload.id ? action.payload : processor_series
        );
      })
      .addCase(addProcessorSeries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorSeries.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_series_list = state.processor_series_list.map((processor_series) =>
          processor_series.id === action.payload.id ? action.payload : processor_series
        );
      })
      .addCase(updateProcessorSeries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorSeries.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorSeries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
